import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (data) => api.post('/api/auth/login', data),
  me: () => api.get('/api/auth/me'),
};

// Projects
export const projectsAPI = {
  list: (params) => api.get('/api/projects', { params }),
  create: (data) => api.post('/api/projects', data),
  get: (id) => api.get(`/api/projects/${id}`),
  update: (id, data) => api.patch(`/api/projects/${id}`, data),
  delete: (id) => api.delete(`/api/projects/${id}`),
  generateScript: (id) => api.post(`/api/projects/${id}/generate-script`),
  approveScript: (id, data) => api.patch(`/api/projects/${id}/script`, data),
  generateAudio: (id) => api.post(`/api/projects/${id}/generate-audio`),
  renderVideo: (id) => api.post(`/api/projects/${id}/render-video`),
  retryVideo: (id) => api.post(`/api/projects/${id}/retry-video`),
};

// Assets
export const assetsAPI = {
  avatars: () => api.get('/api/avatars'),
  voices: () => api.get('/api/voices'),
};

// Transcription
export const transcribeAPI = {
  transcribe: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/api/transcribe', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },
};

// Smart Research
export const researchAPI = {
  start: () => api.post('/api/smart-research'),
  poll: (taskId) => api.get(`/api/smart-research/${taskId}`),
};

// Admin
export const adminAPI = {
  listUsers: (params) => api.get('/api/admin/users', { params }),
  approveUser: (userId) => api.post(`/api/admin/users/${userId}/approve`),
  rejectUser: (userId) => api.post(`/api/admin/users/${userId}/reject`),
};

export default api;
